import { useEffect, useState, useRef, useCallback } from "react";

const SCROLL_DIRECTION_THRESHOLD = 30;

export const useScrolling = (
    classNameOnScrollUp: string,
    ref: React.RefObject<Element>,
    scrollDirectionThreshold: number = SCROLL_DIRECTION_THRESHOLD
) => {
    const [isScrollingUp, setIsScrollingUp] = useState(false);
    const lastScrollY = useRef(0);

    const onScroll = useCallback(() => {
        const scrollY = window.scrollY;

        if (
            Math.abs(scrollY - lastScrollY.current) < scrollDirectionThreshold
        ) {
            return;
        }

        setIsScrollingUp(scrollY < lastScrollY.current);

        lastScrollY.current = scrollY > 0 ? scrollY : 0;
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", onScroll);

        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        if (isScrollingUp) {
            ref.current.classList.add(classNameOnScrollUp);
        } else {
            ref.current.classList.remove(classNameOnScrollUp);
        }
    }, [isScrollingUp]);
};
